import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBell, FaTrash, FaCheckDouble, FaCalendarAlt, FaQrcode, FaStar, FaExclamationTriangle, FaShoppingCart } from 'react-icons/fa';
import { useNotifications } from '../context/NotificationContext';

const TYPE_META = {
  new:    { icon: <FaCalendarAlt />,    color: '#22c55e', bg: '#f0fdf4', label: 'Rezervasiya' },
  order:  { icon: <FaShoppingCart />,   color: '#f97316', bg: '#fff7ed', label: 'Sifariş' },
  warn:   { icon: <FaExclamationTriangle />, color: '#f59e0b', bg: '#fffbeb', label: 'Xəbərdarlıq' },
  scan:   { icon: <FaQrcode />,         color: '#667eea', bg: '#f0f0ff', label: 'QR Scan' },
  review: { icon: <FaStar />,           color: '#f59e0b', bg: '#fffbeb', label: 'Rəy' },
  waiter: { icon: <FaBell />,           color: '#E63950', bg: '#fff0f2', label: 'Ofisiant Çağırışı' },
};

const TABS = [
  { key: 'all',    label: 'Hamısı' },
  { key: 'unread', label: 'Oxunmamış' },
  { key: 'waiter', label: '🔔 Ofisiant' },
  { key: 'order',  label: '🛒 Sifarişlər' },
  { key: 'new',    label: 'Rezervasiya' },
  { key: 'scan',   label: 'QR Scan' },
  { key: 'review', label: 'Rəy' },
];

function timeAgo(val) {
  if (!val) return '';
  const ts = typeof val === 'number' ? val : new Date(val).getTime();
  const m = Math.floor((Date.now() - ts) / 60000);
  if (m < 1)  return 'İndicə';
  if (m < 60) return `${m} dəq əvvəl`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} saat əvvəl`;
  return `${Math.floor(h / 24)} gün əvvəl`;
}

const NotificationsPage = () => {
  const { notifLog, unreadCount, markAllRead, clearLog, pendingCount } = useNotifications();
  const [tab, setTab] = useState('all');
  const navigate = useNavigate();

  const filtered = notifLog.filter(n => {
    if (tab === 'unread') return !n.read;
    if (tab === 'all')   return true;
    return n.type === tab;
  });

  return (
    <div style={{ padding: '24px', maxWidth: 760, margin: '0 auto' }}>

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 24, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: '#1a1a2e' }}>
            🔔 Bildirişlər
          </h1>
          <p style={{ margin: '4px 0 0', fontSize: 13, color: '#94a3b8' }}>
            {notifLog.length} bildiriş
            {unreadCount > 0 && <span style={{ color: '#E63950', fontWeight: 700 }}> · {unreadCount} oxunmamış</span>}
          </p>
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {pendingCount > 0 && (
            <button
              onClick={() => navigate('/bookings')}
              style={actionBtn('#E63950')}
            >
              📅 {pendingCount} gözləyən rezervasiya →
            </button>
          )}
          {unreadCount > 0 && (
            <button onClick={markAllRead} style={actionBtn('#667eea')}>
              <FaCheckDouble style={{ fontSize: 12 }} /> Hamısını oxu
            </button>
          )}
          {notifLog.length > 0 && (
            <button onClick={clearLog} style={actionBtn('#ef4444')}>
              <FaTrash style={{ fontSize: 12 }} /> Sil
            </button>
          )}
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        {TABS.map(t => {
          const count = t.key === 'unread' ? unreadCount
            : t.key === 'all' ? notifLog.length
            : notifLog.filter(n => n.type === t.key).length;
          return (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              style={{
                padding: '7px 16px', borderRadius: 20, fontSize: 13, fontWeight: 600,
                border: 'none', cursor: 'pointer', transition: 'all 0.15s',
                background: tab === t.key ? '#E63950' : '#f5f5f5',
                color: tab === t.key ? '#fff' : '#555',
                display: 'flex', alignItems: 'center', gap: 6,
              }}
            >
              {t.label}
              {count > 0 && (
                <span style={{
                  background: tab === t.key ? 'rgba(255,255,255,0.3)' : '#e5e7eb',
                  color: tab === t.key ? '#fff' : '#555',
                  borderRadius: 10, fontSize: 11, fontWeight: 800,
                  padding: '1px 6px', minWidth: 18, textAlign: 'center',
                }}>
                  {count}
                </span>
              )}
            </button>
          );
        })}
      </div>

      {/* List */}
      {filtered.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '70px 0', color: '#cbd5e1' }}>
          <FaBell style={{ fontSize: 48, marginBottom: 14 }} />
          <p style={{ fontSize: 14, color: '#94a3b8' }}>Bu kateqoriyada bildiriş yoxdur</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {filtered.map(n => {
            const meta = TYPE_META[n.type] || TYPE_META.new;
            return (
              <div
                key={n.id}
                style={{
                  background: n.read ? '#fff' : meta.bg,
                  border: `1.5px solid ${n.read ? '#f0f0f0' : '#e5e7eb'}`,
                  borderLeft: `4px solid ${meta.color}`,
                  borderRadius: 12, padding: '14px 18px',
                  display: 'flex', gap: 14, alignItems: 'flex-start',
                  boxShadow: n.read ? 'none' : '0 2px 8px rgba(0,0,0,0.04)',
                  transition: 'all 0.2s',
                }}
              >
                <div style={{
                  width: 38, height: 38, borderRadius: 10, flexShrink: 0,
                  background: meta.color + '20',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: meta.color, fontSize: 15,
                }}>
                  {meta.icon}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                    <span style={{ fontWeight: 700, fontSize: 14, color: '#1a1a2e' }}>{n.title}</span>
                    <span style={{ fontSize: 11, color: '#94a3b8', whiteSpace: 'nowrap', flexShrink: 0 }}>
                      {timeAgo(n.ts || n.created_at)}
                    </span>
                  </div>
                  {n.body && (
                    <p style={{ margin: '4px 0 0', fontSize: 13, color: '#64748b', wordBreak: 'break-word' }}>
                      {n.body}
                    </p>
                  )}
                  {!n.read && (
                    <span style={{
                      display: 'inline-block', marginTop: 6,
                      padding: '2px 8px', borderRadius: 10,
                      background: meta.color, color: '#fff',
                      fontSize: 10, fontWeight: 700, letterSpacing: 0.5,
                    }}>
                      YENİ
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

const actionBtn = (color) => ({
  display: 'flex', alignItems: 'center', gap: 6,
  padding: '8px 14px', borderRadius: 8, border: 'none',
  background: color + '15', color, fontWeight: 600,
  fontSize: 13, cursor: 'pointer', whiteSpace: 'nowrap',
});

export default NotificationsPage;
